import { exists } from '@/api'

export interface BatchOrderAcceptListConditionListItem {
  orderDateFrom: string
  orderDateTo: string
  rdoOrderType: string
  acceptType: string
  orderBranch: string
  orderCollectionType: string
  isCollectionPeriod: boolean
  rdoOrderListOrder: string
  rdoSituationListOutput: string
  ndcDigits: string
  rdoAmountDispType: string
  rdoOutputConditionType: string
  traderType: string
  donorType: string
  budgetDepType: string
  acceptanceSearchBooks: boolean
  acceptanceSearchAV: boolean
  acceptanceSearchMagazine: boolean
  rdoAutoOrderType: string
  orderNumFrom: string
  orderNumTo: string
  isTargetAlreadyOrder: boolean
  isTargetNotOrder: boolean
  batchType: string
}

export function BatchOrderAcceptListConditionListItemFromJSON(
  json: any
): BatchOrderAcceptListConditionListItem {
  const resp = JSON.parse(json)

  return {
    orderDateFrom: exists(resp, 'order_date_from') ? resp.order_date_from : '',
    orderDateTo: exists(resp, 'order_date_to') ? resp.order_date_to : '',
    rdoOrderType: exists(resp, 'rdo_order_type') ? resp.rdo_order_type : '1',
    acceptType: exists(resp, 'accept_type') ? resp.accept_type : '',
    orderBranch: exists(resp, 'order_branch') ? resp.orderBranch : '',
    orderCollectionType: exists(resp, 'order_collection_type')
      ? resp.order_collection_type
      : '',
    isCollectionPeriod: exists(resp, 'is_collection_period')
      ? resp.is_collection_period
      : false,
    rdoOrderListOrder: exists(resp, 'rdo_order_list_order')
      ? resp.rdo_order_list_order
      : '1',

    rdoSituationListOutput: exists(resp, 'rdo_situation_list_output')
      ? resp.rdo_situation_list_output
      : '1',
    ndcDigits: exists(resp, 'ndc_digits') ? resp.ndc_digits : '',
    rdoAmountDispType: exists(resp, 'rdo_amount_disp_type')
      ? resp.rdo_amount_disp_type
      : '1',
    rdoOutputConditionType: exists(resp, 'rdo_output_condition_type')
      ? resp.rdo_output_condition_type
      : '1',
    traderType: exists(resp, 'trader_type') ? resp.trader_type : '',
    donorType: exists(resp, 'donor_type') ? resp.donor_type : '',
    budgetDepType: exists(resp, 'budget_dep_type') ? resp.budget_dep_type : '',
    acceptanceSearchBooks: exists(resp, 'acceptance_search_books')
      ? resp.acceptance_search_books
      : false,
    acceptanceSearchAV: exists(resp, 'acceptance_search_av')
      ? resp.acceptance_search_av
      : false,
    acceptanceSearchMagazine: exists(resp, 'acceptance_search_av')
      ? resp.acceptance_search_av
      : false,
    rdoAutoOrderType: exists(resp, 'rdo_auto_order_type')
      ? resp.rdo_auto_order_type
      : '1',
    orderNumFrom: exists(resp, 'order_num_from') ? resp.order_num_from : '',
    orderNumTo: exists(resp, 'order_num_to') ? resp.order_num_to : '',
    isTargetAlreadyOrder: exists(resp, 'is_target_already_order')
      ? resp.is_target_already_order
      : false,
    isTargetNotOrder: exists(resp, 'is_target_not_order')
      ? resp.is_target_not_order
      : false,
    batchType: resp.batch_type
  }
}
